import { createContext, useContext, useState, useEffect } from "react";
import { apiFetchAdmin } from '../../hooks/apiFetch';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useLangUrl } from '../../utilities/useLangUrl';

const AdminNotifiContext = createContext();

export function AdminNotifiProvider({ children }) {
    const [orderNotifi, setOrderNotifi] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const langUrl = useLangUrl();

    useEffect(() => {
        if (!Cookies.get('adminToken')) {
            navigate("/admin/adminLogin")
        }
        async function fetchNotifi() {
            try {
                const data = await apiFetchAdmin(`${process.env.REACT_APP_MASAR_API_URL}/notifications/my-notifications`);

                setOrderNotifi(data);
            } catch (err) {
                setOrderNotifi(null);
            } finally {
                setLoading(false);
            }
        }
        fetchNotifi();
    }, [navigate, langUrl]);


    return (
        <AdminNotifiContext.Provider value={{ orderNotifi, setOrderNotifi, loading, setLoading }}>
            {children}
        </AdminNotifiContext.Provider>
    );
}

export function useAdminNotifi() {
    return useContext(AdminNotifiContext);
}